import { useOutletContext } from 'react-router-dom';
import type { Daten } from './laden.js';

/** Gebietsdaten im geschützten Bereich (von App/MitDaten bereitgestellt). */
export function useDatenKontext(): Daten {
  return useOutletContext<Daten>();
}
